<div class="d-flex flex-column" [style.gap.rem]="2">
  <div class="d-flex flex-column">
    <div class="header" i18n>Authenticator App</div>
    <div class="subtext" i18n>
      Scan the QR code below using the authenticator app of your choice such as
      <span class="auth-highlighted-text">Google Authenticator</span>, <span class="auth-highlighted-text">Authy</span>,
      or <span class="auth-highlighted-text">Windows Phone Authenticator</span>.
    </div>
    <ng-container *ngIf="isMobile$ | async">
      <div class="subtext pt-3" i18n>
        On Mobile? Click
        <button class="paddingless-text-button copy-text" (click)="copyToClipboard(mfaKey)">here</button>
        to copy the code to your clipboard.
      </div>
      <hr />
    </ng-container>
  </div>
  <div>
    <canvas #qrCode id="qr-code"></canvas>
    <button class="paddingless-text-button qr-support" (click)="openSupportModal()" i18n>QR Code Support</button>
  </div>

  <div class="subtext" i18n>
    After setting up your authenticator, you will be given a six-digit verification code. Please enter it below.
  </div>

  <div class="d-flex flex-column w-100" [formGroup]="formGroup">
    <div class="d-flex flex-column gap-1">
      <label class="form-input-label" [for]="'timeBasedOneTimePassword'" i18n>Verification Code</label>
      <app-text-input
        #textInput
        formControlName="timeBasedOneTimePassword"
        controlId="timeBasedOneTimePassword"
        [error]="formSubmitted && formGroup.controls.timeBasedOneTimePassword.invalid"
        (keydown.enter)="verifyMfaCode()" />
      <app-form-error
        *ngIf="formSubmitted && formGroup.controls.timeBasedOneTimePassword.invalid"
        [errors]="formGroup.controls.timeBasedOneTimePassword.errors"
        [customErrorMessages]="customErrorMessages.timeBasedOneTimePassword" />
    </div>
  </div>

  <app-button class="w-100" [type]="ButtonTypeEnum.primary" (buttonClick)="verifyMfaCode()" i18n>Submit</app-button>
</div>

<div class="support-button-container">
  <span class="support-button" i18n>Having trouble?</span>
  <button class="paddingless-text-button mt-2" (click)="openContactPage()" i18n>Click here for support</button>
</div>
